import { APP_TYPE } from 'constants/ui';

export const prepareRegistrationData = (data: any) => ({
  // Основные поля
  step: data.registrationType,
  client_id: 0,
  name: data.firstName || '',
  surname: data.lastName || '',
  email: data.email,
  phone: data.phone || '',
  login: '',
  password: data.password,
  currency: data.currencyId,
  country: data.countryName,
  country_id: data.countryId,
  timezone: data.gmt,
  promocode: data.promoCode,
  utm_medium: data.utmMedium,
  utm_source: data.utmSource,
  utm_campaign: data.utmCampaign,
  user_lang: data.language,
  click_id: data.clickId || '',
  device: data.deviceType,
  prefix: APP_TYPE,
  is_sending_email: data.letters === 1,
  city: '',
  region: '',
  postal_code: '',
  address: '',
  gender: 0,
});
